import { inject } from "@angular/core";
import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { LoaderService } from "../../shared/services/loader.service";
import { finalize } from "rxjs";
import { LOADER_SECTION, SHOW_LOADER } from "../auth-context";

export function loaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

  const loaderService = inject(LoaderService);

  const showLoader = req.context.get(SHOW_LOADER);
  const sectionId = req.context.get(LOADER_SECTION);

  if (showLoader) {
    if (sectionId) {
      loaderService.showSection(sectionId);
    } else {
      loaderService.showGlobal();
    }
  }

  return next(req).pipe(
    finalize(() => {
      if (showLoader) {
        if (sectionId) {
          loaderService.hideSection(sectionId);
        } else {
          loaderService.hideGlobal();
        }
      }
    })
  );
}